import { useEffect, useState, useRef } from "react";
import { Button, Card, Checkbox, Col, DatePicker, Form, Input, message, Row, Select, Tooltip } from "antd";
import { useParams } from "react-router-dom";
import { Toast } from 'primereact/toast';
import { ICompanyData } from "../../../interfaces/ICompanyData";
import HTTPService from "../../../utils/makerequest";
import { CloudServerOutlined, DeleteOutlined, HomeOutlined, MailOutlined, PhoneOutlined, UploadOutlined, UserOutlined } from "@ant-design/icons";
import { IUser } from "../../../interfaces/IUser";
import { t } from "i18next";
import { UserRole } from "../../../interfaces/authentication";
import { API_URL } from "../../../utils/Constants";

const UpdateCompany = () => {
  const { companyId } = useParams<any>();
  const [companyData, setCompanyData] = useState<ICompanyData>({});
  const [userData, setUserData] = useState<IUser[]>();
  const [platformData, setPlatformData] = useState<any>();
  const [isChecked, setIsChecked] = useState(false);
  const [logoFiles, setLogoFiles] = useState<any[]>([]);
  const toast = useRef<any>(null);

  useEffect(() => {
    getCompanyData(companyId);
    getUserData(companyId);
    GetPlatform();
  }, [companyId]);


  const GetPlatform = () => {
    HTTPService.GET(`/Other/getPlatform`)
      .then((response) => {
        if (response.status === 200) {

          setPlatformData(response.data);
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(response.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('register_failure'),
          life: 3000
        });
      });
  }


  const getCompanyData = (companyId: number) => {
    HTTPService.GET(`/Company/byId?companyId=${companyId}`)
      .then((res) => {
        if (!res.data) {
          return;
        }
        if (res.status === 200) {
          setCompanyData(res.data);
          setIsChecked(res?.data.isLocal)
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: res.error.message,
            life: 3000
          });
        }
      })
      .catch((error) => {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('error_fetching_data'),
          life: 3000
        });
      });
  };


  const getUserData = (companyId: number) => {
    HTTPService.GET(`/User/allUserName?companyId=${companyId}`)
      .then((res) => {
        if (!res.data) {
          return;
        }
        if (res.status === 200) {
          setUserData(res.data);
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: res.error.message,
            life: 3000
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);
      });
  };

  const updateCompany = (formData) => {
    const updatedCompany = {
      companyId: companyId,
      companyName: formData.companyName,
      companyAddress: formData.companyAddress,
      companyCity: formData.companyCity,
      responsibleUserId: formData.responsibleUserId,
      companyCode: companyData.companyCode,
      isLocal: isChecked,
      baseUrl: formData.baseUrl,
      companyImagePath: logoFiles[0]?.filePath?.split(',')[1],
    };
    HTTPService.PUT(`/Company/updateCompany`, updatedCompany)
      .then((res) => {
        if (res.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(res.data),
            life: 3000
          });
          window.location.replace('/admin/customer-management');
        }
        else if (res.status === 450) {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(res.data),
            life: 3000
          });
        }
        else {
          toast.current?.show({
            severity: 'error',
            summary: t('errors'),
            detail: t(res.data),
            life: 3000
          });
        }
      })
      .catch((error) => {
        toast.current?.show({
          severity: 'error',
          summary: t('errors'),
          detail: t('error_updating_company'),
          life: 3000
        });
      });
  };

  const handleCheckboxChange = (e) => {
    setIsChecked(e?.target.checked);
  };

  const cities = [
    'Adana',
    'Adıyaman',
    'Afyonkarahisar',
    'Ağrı',
    'Amasya',
    'Ankara',
    'Antalya',
    'Artvin',
    'Aydın',
    'Balıkesir',
    'Bilecik',
    'Bingöl',
    'Bitlis',
    'Bolu',
    'Burdur',
    'Bursa',
    'Çanakkale',
    'Çankırı',
    'Çorum',
    'Denizli',
    'Diyarbakır',
    'Edirne',
    'Elazığ',
    'Erzincan',
    'Erzurum',
    'Eskişehir',
    'Gaziantep',
    'Giresun',
    'Gümüşhane',
    'Hakkâri',
    'Hatay',
    'Isparta',
    'Mersin',
    'İstanbul',
    'İzmir',
    'Kars',
    'Kastamonu',
    'Kayseri',
    'Kırklareli',
    'Kırşehir',
    'Kocaeli',
    'Konya',
    'Kütahya',
    'Malatya',
    'Manisa',
    'Kahramanmaraş',
    'Mardin',
    'Muğla',
    'Muş',
    'Nevşehir',
    'Niğde',
    'Ordu',
    'Rize',
    'Sakarya',
    'Samsun',
    'Siirt',
    'Sinop',
    'Sivas',
    'Tekirdağ',
    'Tokat',
    'Trabzon',
    'Tunceli',
    'Şanlıurfa',
    'Uşak',
    'Van',
    'Yozgat',
    'Zonguldak',
    'Aksaray',
    'Bayburt',
    'Karaman',
    'Kırıkkale',
    'Batman',
    'Şırnak',
    'Bartın',
    'Ardahan',
    'Iğdır',
    'Yalova',
    'Karabük',
    'Kilis',
    'Osmaniye',
    'Düzce'
  ];

  const handleCancel = () => {
    window.location.replace('/admin/customer-management/');
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 102400) {
        message.error(t('file_too_100'));
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoFiles([
          ...logoFiles,
          { filePath: reader.result }
        ]);
        message.success(t('logo_uploaded_successfully'));
      };
      reader.onerror = () => {
        message.error(t('logo_upload_failed'));
      };
      reader.readAsDataURL(file);
    }
  };


  const handleRemoveLogo = () => {
    setLogoFiles([]);
    setCompanyData({ ...companyData, companyImagePath: null });
  };

  const logoUrl = `${API_URL}/companyImages/${companyData.companyImagePath}`


  const { Option } = Select;
  return (
    <Card style={{ padding: '50px' }}>
      <Toast ref={toast} />
      <h3>{t('Update Company')}</h3>
      <Form
        layout="vertical"
        onFinish={updateCompany}
        fields={[
          {
            name: ['companyName'],
            value: companyData.companyName,
          },
          {
            name: ['companyAddress'],
            value: companyData.companyAddress,
          },
          {
            name: ['companyCity'],
            value: companyData.companyCity,
          },
          {
            name: ['firstName'],
            value: companyData?.responsibleUserTBL?.firstName,
          },
          {
            name: ['responsibleUserId'],
            value: companyData?.responsibleUserId,
          },
          {
            name: ['isLocal'],
            value: companyData?.isLocal,
          },
          {
            name: ['baseUrl'],
            value: companyData?.baseUrl,
          },
          {
            name: ['companyImagePath'],
            value: logoUrl,
          }
        ]}>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              <Button
                icon={<UploadOutlined />}
                onClick={() => document.getElementById('file-input').click()}
                style={{ padding: '10px 20px', borderRadius: '5px' }}
                disabled={logoFiles.length > 0}
              >
                {t('choose_logo')}
              </Button>

              <input
                id="file-input"
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                style={{ display: 'none' }}
              />

              {logoFiles.length > 0 || companyData?.companyImagePath ? (
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <Tooltip title={t('logo_uploaded')}>
                    <img
                      src={logoFiles && logoFiles.length > 0 ? logoFiles[0].filePath : logoUrl}
                      style={{ width: '100px', marginRight: '10px', maxWidth: '100%', height: 'auto' }}
                    />
                  </Tooltip>

                  <Button
                    icon={<DeleteOutlined />}
                    onClick={handleRemoveLogo}
                    type="text"
                  />
                </div>
              ) : null}

            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          label={t("Company Name")}
          name="companyName"
          rules={[
            {
              required: true,
              message: t('pleaseCompany'),
            },
          ]}
        >
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} />
        </Form.Item>



        {companyData?.baseUrl != null && UserRole.AltisAdmin && (
          <Row gutter={8}>
            <Col xs={20} sm={2}>
              <Form.Item style={{ marginTop: '20px', marginLeft: '5px' }} name="isLocal" valuePropName="checked">
                <div style={{ position: 'relative' }}>
                  <Tooltip title={t('islocal')}>
                    <Checkbox
                      checked={isChecked}
                      style={{ transform: 'scale(1.5)' }}
                      onChange={handleCheckboxChange}
                    />
                  </Tooltip>
                </div>
              </Form.Item>
            </Col>
            <Col xs={20} sm={12}>
              <Form.Item
                name="baseUrl"
                rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (getFieldValue('isLocal')) {
                        if (value && value.trim()) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error(t('please_input', { field: t('baseUrl') })));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                style={{
                  marginTop: '10px',
                  marginLeft: '-60px',
                }}
              >
                <Input
                  prefix={<CloudServerOutlined />}
                  style={{
                    borderRadius: 0,
                    textAlign: 'right',
                    width: 'calc(169% + 60px)',
                    paddingLeft: '8px',
                  }}
                  placeholder={t('baseUrl')}
                  disabled={!isChecked}
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={16}>
          <Col span={16}>
            <Form.Item
              label={t("Address")}
              name="companyAddress"
              rules={[
                {
                  required: true,
                  message: "Please input the address!",
                },
              ]}
            >
              <Input prefix={<HomeOutlined />} style={{ borderRadius: 0 }} />

            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              //label={t('location_city')}
              name='companyCity'
              rules={[
                {
                  required: true,
                  message: 'Please select your city!',
                },
              ]}
              style={{ marginTop: 30 }}
            >
              <Select
                showSearch
                placeholder='Select city'
                optionFilterProp='children'
                filterOption={(input, option) =>
                  option?.children?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {cities.map((city) => (
                  <Option key={city} value={city}>
                    {city}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name='responsibleUserId'
          label={t('responsiblename')}
          rules={[
            {
              required: true,
              message: 'Please select a responsible user!',
            },
          ]}
        >

          <Select
            value={companyData?.responsibleUserTBL?.userId}
            placeholder={t('responsiblename')}
            style={{ marginBottom: '20px' }}
          >
            {userData?.map((user) => (
              <Select.Option key={user.userId} value={user.userId}>
                {user.firstName} {user.lastName}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label={t('companyCode')} style={{ marginTop: '0px' }}>
          <div style={{ borderRadius: 0, backgroundColor: '#ffffff', fontWeight: 'bold', padding: '8px', border: '1px solid #ddd' }}>
            {companyData?.companyCode || t('companyCode')}
          </div>
        </Form.Item>


        {/* <Form.Item
          label="Responsible Firstname"
          name="firstName"
          rules={[
            {
              required: true,
              message: "Please input the responsible firstname!",
            },
          ]}
        >
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} />
        </Form.Item>
        <Form.Item
          label="Responsible Lastname"
          name="lastName"
          rules={[
            {
              required: true,
              message: "Please input the responsible lastname!",
            },
          ]}
        >
          <Input prefix={<UserOutlined />} style={{ borderRadius: 0 }} />
        </Form.Item>
        <Form.Item
          label="Responsible Telephone"
          name="telephone"
          rules={[
            {
              required: true,
              message: "Please input the responsible telephone!",
            },
          ]}
        >
          <Input prefix={<PhoneOutlined />} style={{ borderRadius: 0 }} />
        </Form.Item>
        <Form.Item
          label="Responsible Email"
          name="userEmail"
          rules={[
            {
              required: true,
              message: "Please input the responsible email!",
            },
            {
              type: "email",
              message: "Please input a valid email address!",
            },
          ]}
        >
          <Input prefix={<MailOutlined />} style={{ borderRadius: 0 }} />
        </Form.Item> */}
        <Form.Item>
          <Row gutter={[8, 8]} justify="end" align="middle">
            <Col xs={12} sm={4}>
              <Button block onClick={handleCancel} type="primary" style={{ borderRadius: '5px' }}>
                {t('cancel')}
              </Button>
            </Col>
            <Col xs={12} sm={4}>
              <Button block htmlType="submit" type="primary" style={{ borderRadius: '5px' }}>
                {t('update')}
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default UpdateCompany;
